import { fetchJSON } from "@synbioz/ajax";
import getAuthHeaders from "./getAuthHeaders";
import handleUnauth from "./handleUnauth";

/**
 * @param {Object}   params
 * @param {Object}   [params.user]
 * @param {Function} [params.onUnauth]
 * @param {Boolean}  [params.sendHeaders]
 * @param {String}   [params.headerNamespace]
 * @param {Boolean}  [params.useJSON]
 *
 * @return {Function}
 */
export default function getAuthFetch({ user, onUnauth, sendHeaders = false, headerNamespace = undefined, useJSON = true }) {
  /**
   * @param {String} url
   * @param {Object} [params]
   *
   * @return {Promise} Prepared call to provided fetch method
   */
  return (url, params = {}) => {
    if (sendHeaders) {
      params.headers = getAuthHeaders(params.headers, user, headerNamespace);
    }

    params.credentials = params.credentials || "include";

    if (typeof onUnauth === "function") {
      const handler = handleUnauth(onUnauth);

      return useJSON
        ? fetchJSON(url, params).then(handler)
        : fetch(url, params).then(handler);
    }

    return useJSON
      ? fetchJSON(url, params)
      : fetch(url, params);
  };
}
